export const navLinks = [
    {
        id: 1,
        path:"/",
        name:"home"
    },
    {
        id:2,
        path:"about",
        name:"about us"
    },
    {
        id:3,
        path:"plan",
        name:"create your plan"
    }
]